// Importujemy słowniki JSON jako zwykły obiekt
import pl from "./locales/pl.json";
import en from "./locales/en.json";

/** Typ dozwolonych kodów językowych */
export type LanguageCode = "pl" | "en";

/** Wszystkie tłumaczenia w jednym miejscu */
export const translations: Record<LanguageCode, Record<string, string>> = {
  pl,
  en,
};

/**
 * Funkcja skrótowa do pobierania tłumaczenia.
 * Jeżeli brakuje klucza – zwracamy sam klucz, aby łatwiej było wykryć brak.
 *
 * @param lang   kod języka (np. 'pl')
 * @param key    klucz z JSONa
 * @param vars   zmienne do interpolacji {price: 10}
 */
export function translation(lang: LanguageCode, key: string, vars: Record<string, string | number> = {}): string {
  let text = translations[lang]?.[key] ?? key;

  // Podmieniamy {zmienne} w tekście
  Object.entries(vars).forEach(([placeholder, value]) => {
    text = text.replace(`{${placeholder}}`, String(value));
  });

  return text;
}
